import mitt from "mitt";
export const jobsEventBus = mitt();
